/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: initConfig接口
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-19 17:05:21
 * @LastEditTime: 2022-09-06 16:28:53
 * @FilePath: /client-h5-v2/src/apis/config/initConfigQuery.ts
 */
import httpRequest from '@/request/index'
import { InitConfigQueryParams } from '@/apis/types'
import { apiGetLocalfiles } from '@/apis/config/applicationPropterty'
import store from '@/store/index'

// 获取用户信息
export function apiGetInitConfigQuery (param: InitConfigQueryParams) {
  const projectName = store.getters['global/projectName']
  if (window.botV2GlobalProperties.NODE_ENV === 'development') {
    return apiGetLocalfiles(`/${window.botV2GlobalProperties.BASE_PATH}/json/page-config/${projectName}-pageConfig.json`)
  } else {
    return httpRequest({
      url: '/api/v1/config/initConfig/query',
      method: 'post',
      data: param
    })
  }
}
